import LearnAboutVariableSettlementPlanSection from './learnAboutVariableSettlementPlanSection';

export default LearnAboutVariableSettlementPlanSection;
